<!-- 代理商库存明细 -->
<template>
    <div class="container">
        <div class="header">
            <img class="width_24 mr-12" src="../../assets/information.png">
            <div>
                <div>库存总数每24小时须存更新一次，可以通过更新缓存的方式手动更新。</div>
                <div>1.已经关联了代理（经销）商或门店或者已经零售出库的码，不会计入总部库存。</div>
                <div>2.未入库的码或空码不会计入总部库存。</div>
            </div>
        </div>
        <div class="header_div">
            <Input class="w200 mr-24" type="text" v-model="storePrams.keywords" placeholder="代理（经销）商模糊搜索"></Input>
            <Button icon="ios-search" type="warning" class="theme-bg" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ index }" slot="id">
                        <div>{{ index + 1 }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="agent_name">
                        <div>
                            <div>{{row.agent_name}}</div>
                            <div>授权编号：{{row.agent_number}}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="mobile">
                        <div>
                            <div>联系人：{{row.agent_name}}</div>
                            <div>联系电话：{{row.mobile}}</div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost label="small" @click="goInfo(row)">详情</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 详情 -->
        <Drawer v-model="infoModal" :title="drawerTitle" width="80">
            <div class="drawer_div">
                <Input class="w300 mr-24" type="text" v-model="pagesDrawer.qrcode_number" placeholder="输入溯源码编码或扫描溯源码"></Input>
                <Select class="w200 mr-24" v-model="pagesDrawer.batch_id" clearable filterable placeholder="选择所属批次">
                    <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
                </Select>
                <Select class="w200 mr-24" v-model="pagesDrawer.product_id" clearable filterable placeholder="选择所属产品">
                    <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
                </Select>
                <Button class="theme-bg" icon="ios-search" type="warning" @click="goSearchDrawer">确定搜索</Button>
            </div>
            <Table :columns="columnsDrawer" :data="dataDrawer" border>
                <template slot-scope="{ index }" slot="id">
                    <div>{{ index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div class="flex-c">
                        <img class="width_60 mt-12 mb-12" v-if="row.qrcode.product.show_product_imgs" :src="row.qrcode.product.show_product_imgs[0]">
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product">
                    <div>{{row.qrcode.product.product_name}} {{row.qrcode.product.specs}}</div>
                </template>
                <template slot-scope="{ row }" slot="produce_time">
                    <div>
                        <div>生产时间：{{row.qrcode.produce_time}}</div>
                        <div>到期时间：{{row.qrcode.expire_time}}</div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="batch">
                    <div>{{row.qrcode.batch.batch_name}}</div>
                </template>
                <template slot-scope="{ row }" slot="box">
                    <div>
                        <template v-if="row.box">
                            <div v-if="row.box.big_box_number">大箱：{{row.box.big_box_number}}</div>
                            <div v-if="row.box.small_box_number">小箱：{{row.box.small_box_number}}</div>
                        </template>
                        <template v-else><div><Icon type="ios-alert-outline"/>未装箱</div></template>
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page :current="pagesDrawer.page" :page-size="pagesDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="changeDrawer"/>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { 
    warehouse_agent_list, 
    warehouse_agent_qrcode,
} from '@/api/index';
import { 
    batch_select, 
    product_select,
} from '@/api/select';
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                keywords: "",
            },
            total: 0,
            columnsTable: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "代理（经销）商", slot: "agent_name", align: "center" },
                { title: "联系方式", slot: "mobile", align: "center" },
                { title: "库存总数", key: "warehouse_qrcode_count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "100px" },
            ],
            dataTable: [],
            infoModal: false,
            drawerTitle: "",
            columnsDrawer: [
                { title: "#", slot: "id", align: "center", width: "60px" },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "产品名称及规格", slot: "product", align: "center" },
                { title: "保质期情况", slot: "produce_time", align: "center" },
                { title: "产品溯源码编码", key: "qrcode_number", align: "center" },
                { title: "所属批次", slot: "batch", align: "center" },
                { title: "大(小)箱码", slot: "box", align: "center" },
            ],
            dataDrawer: [],
            pagesDrawer: {
                agent_id: "",
                page: 1,
                limit: 10,
                batch_id: "", 
                qrcode_number: "",
                product_id: "",
            },
            totalDrawer: 0,
            batchList: [],
            productList: [],
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    methods: {
        getList() {
            warehouse_agent_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch(){
            this.getList();
        },
        getInfoList() {
            warehouse_agent_qrcode(this.pagesDrawer).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeDrawer(index) {
            this.pagesDrawer.page = index;
            this.getInfoList();
        },
        goSearchDrawer(){
            this.getInfoList();
        },
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            }).catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        goInfo(row){
            this.drawerTitle = "【" + row.agent_name +"】代理商库存详情";
            this.pagesDrawer.agent_id = row.id;
            this.getInfoList();
            setTimeout(() => {
                this.infoModal = true;
            }, 300);
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    margin-bottom: 24px;
    padding: 24px;
    background: rgba(255,118,29,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
}
.width_24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.header_div {
    padding: 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_60 {
    width: 60px;
    height: 60px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.drawer_div {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 24px 0;
}
</style>